var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWriteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.924,
    cy: 29.213,
    r: 28.6027,
    fill: "#143950"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6087 29.9795L28.5651 23.8956L33.0373 19.4637L31.8689 18.2953L24.1735 25.9907C23.8512 26.313 23.4751 26.4742 23.0454 26.4742C22.6156 26.4742 22.2396 26.313 21.9172 25.9907C21.5949 25.6684 21.4338 25.2856 21.4338 24.8425C21.4338 24.3993 21.5949 24.0165 21.9172 23.6942L29.5724 16.039C30.217 15.3944 30.9758 15.0721 31.8488 15.0721C32.7217 15.0721 33.4805 15.3944 34.1252 16.039L35.2936 17.2075L37.3081 15.193C37.6304 14.8706 38.0132 14.7095 38.4564 14.7095C38.8996 14.7095 39.2823 14.8706 39.6046 15.193L43.3516 18.9399C43.6739 19.2623 43.8351 19.645 43.8351 20.0882C43.8351 20.5314 43.6739 20.9142 43.3516 21.2365L34.6087 29.9795ZM16.4378 43.7184C15.9812 43.7184 15.5984 43.564 15.2895 43.2551C14.9806 42.9462 14.8262 42.5634 14.8262 42.1068V39.0045C14.8262 38.5747 14.9068 38.1651 15.0679 37.7756C15.2291 37.3861 15.4574 37.0437 15.7528 36.7482L26.2686 26.1922L32.3524 32.2357L21.7964 42.7917C21.5009 43.0872 21.1584 43.3155 20.769 43.4767C20.3795 43.6378 19.9699 43.7184 19.5401 43.7184H16.4378Z",
    fill: "#8ED1DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteIcon);
export default __webpack_public_path__ + "static/media/writeIcon.b2afcb006b71ded07204590c2a680e6e.svg";
export { ForwardRef as ReactComponent };